import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../redux/slice/form";

import { ModuleSubHead, ModuleHeadLine } from "../../components/other";

import { Button } from "primereact/button";

export default function FrontChooseForm() {
  const dispatch = useDispatch();
  const route_navigate = useNavigate();
  const formList = [
    {
      key: "treatment",
      title: "近視治療",
      subTitle: "您的小孩需要考慮治療",
      content: "當小孩被診斷為近視時，我應該讓小孩接受治療嗎?",
    },
    {
      key: "control",
      title: "光學控制",
      subTitle: "您的小孩需要考慮光學鏡片矯正",
      content: "我的孩子近視了，該配戴哪一種眼鏡?",
    },
  ];

  return (
    <>
      <div className="flex flex-column h-full">
        <ModuleSubHead isDefault={true} lineType="one" />

        <div className="relative text-center md:text-left -mx-3 my-6">
          <ModuleHeadLine className="absolute top-50 left-0 w-full -mt-1" />
          <span className="md:ml-6">
            <span className="relative text-4xl sm:text-5xl md:text-6xl bg-white md:ml-6 px-3">
              兒童近視SDM評估表單
            </span>
          </span>
        </div>

        <div className="flex flex-column flex-auto px-4 mb-4">
          <div className="text-2xl sm:text-3xl md:text-4xl text-main font-bold">
            請依照您的小孩實際情況選擇進入以下表單
          </div>

          {formList.map((item) => (
            <div key={item.key} className="font-bold mt-6">
              <div className="flex align-items-center flex-wrap sm:flex-nowrap text-xl md:text-2xl mb-2">
                <div className="bg-yellow-100 border-1 border-400 border-round-md px-3 py-2 mr-2 flex-order-0">
                  {item.title}
                </div>
                <div className="border-1 border-400 border-round-md w-full sm:w-auto px-3 py-2 mt-2 sm:mt-0 flex-order-2 sm:flex-order-1">
                  {item.subTitle}
                </div>
                <Button
                  className="md:p-button-lg p-button-main text-xl md:text-2xl px-4 mr-2 sm:ml-2 flex-order-1 sm:flex-order-2"
                  type="button"
                  label="進入表單"
                  onClick={() => {
                    dispatch(setFormType(item.key));
                    dispatch(setFormStep(""));
                    dispatch(setFormUser(null));
                    dispatch(setFormDetail({}));
                    route_navigate("/basicForm");
                  }}
                />
              </div>
              <div className="w-full lg:w-8 xl:w-7 text-2xl md:text-3xl bg-blue-50 border-1 border-400 border-round-md p-3">
                {item.content}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
